var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.2C9.36005 25.2 4.80005 20.64 4.80005 15C4.80005 9.36 9.36005 4.8 15 4.8C20.64 4.8 25.2001 9.36 25.2001 15C25.2001 20.64 20.64 25.2 15 25.2ZM15 6C10.02 6 6.00005 10.02 6.00005 15C6.00005 19.98 10.02 24 15 24C19.98 24 24 19.98 24 15C24 10.02 19.98 6 15 6Z",
    fill: "#499468"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 19.44L8.57996 14.22L9.41996 13.38L13.8 17.76L20.58 10.98L21.42 11.82L13.8 19.44Z",
    fill: "#499468"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.8ce6946ea2023da8b42318dc0fadb543.svg";
export { ForwardRef as ReactComponent };